import isSkillKnowledgePath from '@/lib/isSkillKnowledgePath.js';

const buildResetActiveCompanyScopeState = ({ state, initialState, payload }) => {
  const normalizedCompanyId = String(payload?.companyId || '').trim() || null;
  const userScopedSkillKnowledge = (Array.isArray(state?.knowledge) ? state.knowledge : []).filter((row) => {
    return isSkillKnowledgePath(row?.path);
  });

  return {
    ...initialState,
    // Provider switches and request boundaries belong to the person across workspaces (L29).
    passthroughProviders: state?.passthroughProviders || initialState.passthroughProviders,
    passthroughSwitchMutations: Object.fromEntries(Object.entries(state?.passthroughSwitchMutations || {}).filter(([key]) => key.startsWith('provider:'))),
    runtime: {
      ...(initialState.runtime || {}),
      ...(state?.runtime || {}),
      branchName: '',
      accessLabel: ''
    },
    appsMetadataItems: Array.isArray(state?.appsMetadataItems) ? state.appsMetadataItems : initialState.appsMetadataItems,
    appsMetadataEtag: state?.appsMetadataEtag || initialState.appsMetadataEtag,
    appsMetadataLoaded: state?.appsMetadataLoaded === true,
    triggerAppActionsByAppRef: state?.triggerAppActionsByAppRef || initialState.triggerAppActionsByAppRef,
    triggerAppActionErrorsByAppRef: state?.triggerAppActionErrorsByAppRef || initialState.triggerAppActionErrorsByAppRef,
    triggerAppActionsLoadedByAppRef: state?.triggerAppActionsLoadedByAppRef || initialState.triggerAppActionsLoadedByAppRef,
    knowledge: userScopedSkillKnowledge,
    activeCompanyScopeCompanyId: normalizedCompanyId
  };
};

export default buildResetActiveCompanyScopeState;
